import React from 'react'

function IconTBancaire({className='stroke-[#20C374]'}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.34375 16.1981L16.1727 3.36914M18.6296 11.0561L16.4302 13.2556M14.5529 15.1104L13.5742 16.0891"  strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M3.17467 16.1411C1.60844 14.5749 1.60844 12.0355 3.17467 10.4693L10.4693 3.17467C12.0355 1.60844 14.5749 1.60844 16.1411 3.17467L20.8253 7.85891C22.3916 9.42514 22.3916 11.9645 20.8253 13.5307L13.5307 20.8253C11.9645 22.3916 9.42514 22.3916 7.85891 20.8253L3.17467 16.1411Z"  strokeWidth="1.5"/>
        <path d="M4 22H20"  strokeWidth="1.5" strokeLinecap="round"/>
        </svg>

  )
}

export default IconTBancaire
